/**
 * Detects if the device is a mobile platform (iOS / Android)
 */
let _isMobile: boolean | null = null;

export const isMobileDevice = (): boolean => {
  if (_isMobile !== null) return _isMobile;
  if (typeof window === "undefined" || !window.navigator) return false;
  _isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  return _isMobile;
};

/**
 * Attempts to open a native app using a custom URI scheme.
 * If the app is not installed or doesn't open within the timeout,
 * it falls back to opening the standard web URL in a new window/tab.
 */
export const openAppWithFallback = (appUrl: string, webUrl: string) => {
  if (isMobileDevice()) {
    // On mobile, standard HTTPS links (Universal Links / App Links) are natively
    // intercepted by the OS. Triggering custom schemes can throw errors (like Safari's "Invalid Address"),
    // so we directly open the universal HTTPS link.
    window.open(webUrl, "_blank", "noopener,noreferrer");
    return;
  }

  let appOpened = false;

  const handleBlur = () => {
    appOpened = true;
  };

  window.addEventListener("blur", handleBlur);

  try {
    window.location.href = appUrl;
  } catch {
    // Ignore issues triggering protocol
  }

  setTimeout(() => {
    window.removeEventListener("blur", handleBlur);
    if (!appOpened) {
      window.open(webUrl, "_blank", "noopener,noreferrer");
    }
  }, 1200);
};

/**
 * Resolves a LinkedIn profile URL (e.g. https://www.linkedin.com/in/shubham-mittal-03112/)
 * to a custom linkedin:// scheme profile link.
 */
export const getLinkedInAppUrl = (webUrl: string): string => {
  try {
    const url = new URL(webUrl);
    const pathname = url.pathname;
    const segments = pathname.split("/").filter(Boolean);
    
    const inIdx = segments.indexOf("in");
    if (inIdx !== -1 && segments[inIdx + 1]) {
      return `linkedin://profile/in/${segments[inIdx + 1]}`;
    }
    
    return `linkedin://profile/in/arora-sir`;
  } catch {
    return `linkedin://profile/in/arora-sir`;
  }
};
